import { Link } from "react-router-dom";
import { Car, Home as HomeIcon, Briefcase, Cpu, Armchair, Wrench, PawPrint, Shirt, ArrowRight } from "lucide-react";
import { CATEGORIES } from "@/lib/api";
import { ListingRow } from "@/components/Listings";

const ICONS = { Car, Home: HomeIcon, Briefcase, Cpu, Armchair, Wrench, PawPrint, Shirt };

function SectionHeading({ title, label }) {
  return (
    <div className="flex items-end justify-between border-b-2 border-black pb-2">
      <h2 className="font-display text-2xl md:text-3xl uppercase">/ {title}</h2>
      <span className="hidden md:inline font-mono-data text-xs uppercase text-gray-600">{label}</span>
    </div>
  );
}

export function CategoryGrid({ counts }) {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 mt-12">
      <SectionHeading title="Browse Categories" label="SECTION 01" />
      <div className="grid grid-cols-2 md:grid-cols-4 border-l-2 border-t-2 border-black" data-testid="categories-grid">
        {CATEGORIES.map((cat) => {
          const Icon = ICONS[cat.icon] || Briefcase;
          return (
            <Link key={cat.slug} to={`/category/${cat.slug}`} data-testid={`category-link-${cat.slug}`} className="border-r-2 border-b-2 border-black p-5 hover:bg-yellow-100 group no-underline text-black hover:no-underline transition-colors">
              <Icon size={28} strokeWidth={2} className="mb-3 group-hover:text-[#0000EE]" />
              <div className="font-display text-lg uppercase tracking-tight">{cat.name}</div>
              <div className="font-mono-data text-xs uppercase text-gray-600 mt-1">{counts[cat.slug] ?? 0} listings →</div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export function LatestListings({ listings }) {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 mt-16">
      <SectionHeading title="Latest Listings" label="SECTION 02 — REVERSE CHRONOLOGICAL" />
      <div className="border-x-2 border-b-2 border-black" data-testid="latest-listings-list">
        <div className="hidden md:grid grid-cols-12 gap-2 px-3 py-2 bg-black text-white font-mono-data text-xs uppercase">
          <div className="col-span-1">Posted</div>
          <div className="col-span-7">Title / Description</div>
          <div className="col-span-2">Price</div>
          <div className="col-span-2 text-right">Location</div>
        </div>
        {listings.length === 0 && <div className="p-8 text-center font-mono-data text-sm uppercase text-gray-500">No listings yet — be the first.</div>}
        {listings.map((l) => <ListingRow key={l.listing_id} listing={l} />)}
      </div>
    </section>
  );
}

export function PostCta() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 mt-16">
      <div className="border-2 border-black bg-[#0000EE] text-white p-6 md:p-10 flex flex-col md:flex-row items-center justify-between gap-4 hard-shadow">
        <div>
          <h3 className="font-display text-2xl md:text-4xl uppercase leading-none">Got something to sell?</h3>
          <p className="font-mono-data text-xs uppercase mt-2 opacity-90">Free to post. No middlemen. No fees.</p>
        </div>
        <Link to="/post" data-testid="cta-post-link" className="bg-white text-black px-6 py-3 border-2 border-white font-mono-data uppercase text-sm hover:bg-black hover:text-white hover:border-white flex items-center gap-2 no-underline hover:no-underline">
          Post an Ad <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  );
}
